module.exports = __webpack_public_path__ + "img/milestones.caef9397.svg";